import { render, staticRenderFns } from "./RegisterDeviceTMA.vue?vue&type=template&id=53ab24ad&"
import script from "./RegisterDeviceTMA.vue?vue&type=script&lang=js&"
export * from "./RegisterDeviceTMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports